import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import styled from "@emotion/styled";
import { Form, Input, Button, Modal } from "antd";

import { responsive } from "../../utils/style";
import { css } from "@emotion/react";
import "./register.module.css";
import Api from "../../utils/api";
import { useNavigate } from "react-router-dom";
import { FieldContainer } from "../../components/CustomFields";
import { passwordRegexp } from "../../utils/password";
import CheckIcon from "../../assets/icons/checkWithBg.svg";
import Consent from "../../components/Pdpa/Consent";

const RegisterQuiz = () => {
  const navigate = useNavigate();

  const [form] = Form.useForm();
  const [showModal, setShowModal] = useState(false);

  const [consent, setConsent] = useState(false);

  const onFinish = async (values) => {
    await Api.post("authen/publicUserRegister", values)
      .then((res) => {
        if (res.status === 200) {
          setShowModal(true);
          setTimeout(() => {
            setShowModal(false);
            navigate("/login/quiz");
          }, 100);
        } else {
          alert("เกิดข้อผิดพลาดในระบบ");
        }
      })
      .catch((err) => {
        const { response } = err;
        alert(response.data);
      });
  };

  return (
    <>
      {consent ? (
        <Container>
          <Background>
            <Title>ลงทะเบียนทำแบบทดสอบ</Title>
            <FormContainer>
              <Form
                form={form}
                name="register-quiz"
                layout="vertical"
                style={{ width: "100%" }}
                onFinish={onFinish}
                autoComplete="off"
                size="large"
              >
                <FieldContainer
                  name="username"
                  label="ชื่อผู้ใช้งาน (USERNAME)"
                  rules={[
                    { required: true, message: "โปรดระบุ" },
                    {
                      pattern: passwordRegexp,
                      message: `ประกอบด้วยตัวเลข (0-9) หรือตัวอักษรภาษาอังกฤษ(a-z)`,
                    },
                    { min: 8, message: "ต้องมีความยาวไม่น้อยกว่า 8 ตัวอักษร" },
                  ]}
                  hasFeedback
                  marginBottom={0}
                >
                  <Input placeholder="โปรดระบุ" style={{ padding: "11px" }} />
                </FieldContainer>

                <FieldContainer
                  name="password"
                  label="รหัสผ่าน"
                  rules={[
                    { required: true, message: "โปรดระบุ" },
                    {
                      pattern: passwordRegexp,
                      message: `ประกอบด้วยตัวเลข (0-9) หรือตัวอักษรภาษาอังกฤษ(a-z)`,
                    },
                    { min: 8, message: "ต้องมีความยาวไม่น้อยกว่า 8 ตัวอักษร" },
                  ]}
                  hasFeedback
                  marginBottom={0}
                >
                  <Input
                    placeholder="โปรดระบุ"
                    type="password"
                    style={{ padding: "11px" }}
                  />
                </FieldContainer>

                <FieldContainer
                  name="passwordConfirm"
                  label="ใส่รหัสผ่านอีกครั้ง"
                  rules={[
                    { required: true, message: "โปรดระบุ" },
                    {
                      pattern: passwordRegexp,
                      message: `ประกอบด้วยตัวเลข (0-9) หรือตัวอักษรภาษาอังกฤษ(a-z)`,
                    },
                    { min: 8, message: "ต้องมีความยาวไม่น้อยกว่า 8 ตัวอักษร" },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue("password") === value) {
                          return Promise.resolve();
                        }

                        return Promise.reject(new Error("รหัสผ่านไม่ตรงกัน!"));
                      },
                    }),
                  ]}
                  hasFeedback
                  marginBottom={0}
                >
                  <Input
                    placeholder="โปรดระบุ"
                    type="password"
                    style={{ padding: "11px" }}
                  />
                </FieldContainer>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      height: "100%",
                      backgroundColor: "#323A46",
                      marginLeft: "10px",
                      marginRight: "10px",
                      borderRadius: "8px",
                      color: "white",
                    }}
                  >
                    <p
                      style={{
                        paddingLeft: "10px",
                        paddingRight: "10px",
                        paddingTop: "10px",
                        fontSize: "14px",
                      }}
                    >
                      คำแนะนำการตั้งรหัสผ่าน <br />
                      <ul
                        style={{
                          paddingLeft: "24px",
                          paddingRight: "10px",
                        }}
                      >
                        <li>ต้องมีความยาวไม่น้อยกว่า 8 ตัวอักษร</li>
                        <li>
                          ประกอบด้วยตัวเลข (0-9) หรือตัวอักษรภาษา อังกฤษ(a-z)
                        </li>
                        <li>โปรดตั้งรหัสผ่านที่จดจำได้ง่าย</li>
                      </ul>
                    </p>
                  </div>
                </div>

                <Form.Item shouldUpdate style={{ marginTop: "24px" }}>
                  {() => (
                    <Button
                      type="primary"
                      htmlType="submit"
                      disabled={
                        !form.isFieldsTouched(true) ||
                        !!form
                          .getFieldsError()
                          .filter(({ errors }) => errors.length).length
                      }
                    >
                      ลงทะเบียน
                    </Button>
                  )}
                </Form.Item>
              </Form>
            </FormContainer>
            <Textlink href="/login/quiz">เข้าสู่ระบบ</Textlink>
            <Modal
              visible={showModal}
              closable={true}
              footer={null}
              onCancel={() => setShowModal(false)}
              style={{
                fontFamily: `"Noto Sans Thai", "Noto Sans"`,
              }}
            >
              <center>
                <img src={CheckIcon} width="144px" height="144px" />
                <br />
                <div style={{ marginTop: "16px" }}>
                  <span
                    style={{
                      fontSize: "20px",
                      color: "#058459",
                      fontWeight: "600",
                    }}
                  >
                    ลงทะเบียนสำเร็จ
                  </span>
                  <br />
                  <span style={{ fontSize: "18px", color: "#4B5768" }}>
                    คุณสามารถเข้าใช้งาน ได้ทันที
                  </span>
                </div>
              </center>
            </Modal>
          </Background>
        </Container>
      ) : (
        <Consent onConsent={() => setConsent(true)} />
      )}
    </>
  );
};

const Textlink = styled.a`
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 26px;
  text-align: center;
  color: #4b5768;
`;

const Title = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 23px;
  line-height: 28px;
  color: #058459;
  margin-top: 40px;
`;

const Container = styled.div`
  width: 100%;
  background-color: #fffbeb;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "Noto Sans Thai", "Noto Sans";
`;

const Background = styled.div`
  width: 100%;
  max-width: 1144px;

  background-color: white;
  display: flex;
  flex-direction: column;
  align-items: center;

  padding-bottom: 80px;

  span {
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    text-align: center;

    color: #4b5768;
  }

  ${responsive.tablet(css`
    max-width: 834px;
    padding-bottom: 50px;
  `)}

  ${responsive.mobile(css`
    max-width: 375px;
    padding-bottom: 40px;
  `)}
`;

const FormContainer = styled.div`
  margin: 40px 0 0 0;
  width: 60%;

  > form > div {
    margin-bottom: 24px;
  }

  ${responsive.mobile(css`
    width: 90%;
  `)}

  form label {
    font-style: normal;
    font-weight: 500;
    color: #4b5768;
    font-size: 21px;
    height: auto !important;
  }

  div {
    padding-bottom: 0;
  }

  span {
    text-align: left;
  }

  input {
    border-radius: 4px;
    font-size: 18px;
    border: 1px solid #a0abbb;
    box-sizing: border-box;
  }

  #login_username,
  .ant-input,
  .ant-input-password {
    height: 52px;
  }
`;
export default RegisterQuiz;
